import { DependencyList, RefObject, useEffect } from "react";

type TScrollContainer = HTMLElement | null;

export const scrollToTop = (behavior: ScrollBehavior = "auto", container?: TScrollContainer) => {
  if (container) {
    if (behavior === "auto" || typeof container.scrollTo !== "function") {
      container.scrollTop = 0;
      container.scrollLeft = 0;
      return;
    }

    container.scrollTo({ top: 0, left: 0, behavior });
    return;
  }

  if (typeof window !== "undefined") {
    window.scrollTo({ top: 0, left: 0, behavior });
  }
};

export const useScrollToTop = (
  behavior: ScrollBehavior = "auto",
  dependencies: DependencyList = [],
  containerRef?: RefObject<HTMLElement | null>,
) => {
  useEffect(() => {
    const resetScroll = () => scrollToTop(behavior, containerRef?.current);

    resetScroll();
    const frame = requestAnimationFrame(resetScroll);

    return () => cancelAnimationFrame(frame);
    // Dependencies are intentionally supplied by the hook consumer.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [behavior, containerRef, ...dependencies]);
};
